// Stroke icons from the "Billing Info & Payment 2.0" design for the left navigation bar.
interface SidebarIconProps {
  size?: number;
  strokeWidth?: number;
}

const createIcon = (paths: string[], defaultSize: number, defaultStrokeWidth: number) => (
  { size = defaultSize, strokeWidth = defaultStrokeWidth }: SidebarIconProps,
) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    {paths.map(d => <path key={d} d={d} />)}
  </svg>
);

export const LayersIcon = createIcon([
  'M12 2.6 2.8 7.3 12 12l9.2-4.7z',
  'M2.8 12 12 16.7 21.2 12',
  'M2.8 16.7 12 21.4l9.2-4.7',
], 21, 1.7);

export const UserPlusIcon = createIcon([
  'M15 19v-1a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v1',
  'M8.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
  'M19 8v6',
  'M22 11h-6',
], 21, 1.7);

export const CardIcon = createIcon([
  'M5.5 6h13a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 15.5v-7A2.5 2.5 0 0 1 5.5 6z',
  'M3 10.2h18',
], 21, 1.7);

export const HistoryIcon = createIcon([
  'M21 12a9 9 0 1 1-3-6.7',
  'M21 4v4h-4',
  'M12 7.5v5l3.5 2',
], 21, 1.7);

export const ShieldIcon = createIcon([
  'M12 3l7 3v5c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z',
  'M9 12l2 2 4-4',
], 21, 1.7);

export const MailIcon = createIcon([
  'M3.5 5.5h17v13h-17z',
  'M4 6.2l8 5.6 8-5.6',
], 18, 1.7);

export const SwitchIcon = createIcon([
  'M4 9h13',
  'M14 6l3 3-3 3',
  'M20 15H7',
  'M10 12l-3 3 3 3',
], 18, 1.9);

export const LogoutIcon = createIcon([
  'M9 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3',
  'M16 17l5-5-5-5',
  'M21 12H9',
], 18, 1.9);

export const PanelToggleIcon = createIcon([
  'M4.6 5.5h14.8a1.6 1.6 0 0 1 1.6 1.6v9.8a1.6 1.6 0 0 1-1.6 1.6H4.6A1.6 1.6 0 0 1 3 16.9V7.1a1.6 1.6 0 0 1 1.6-1.6z',
  'M9.4 5.5v13',
], 20, 2);

export const ChevronIcon = createIcon([
  'M6 9.5l6 6 6-6',
], 16, 2.3);

export const ExternalIcon = createIcon([
  'M7 17 17 7',
  'M9 7h8v8',
], 15, 2);
